import _ from 'lodash'

import styles from './FieldConfig.css'

import {
  InputCountField,
  InputField,
  RadioGroupInputField,
  CheckboxMenuSelectField,
  SingleLineTextField,
  TextareaCountField
} from '../../../../Common/Form'
import {
  normalizeSeoUrl,
  removeSpaceAndTab,
  maxLengthNormalizer,
  normalizeAll,
  filterHtmlTag,
  filterHtmlTagAndSpace
} from './normalizers'
import { validateProductWeight, validateContentRating } from './validation/fieldLevelValidator'
import { skipRequiredThenValidate, validateBarcode, validateFlow } from './validation/validations'
import { length } from 'redux-form-validators'
import { SHIP_TYPE_ID_FIELD_NAME } from '../../../../../lib/ReduxFormSelectors/ProposalListingForm'
import { required } from '../../../../../lib/FormHelper'
import ShortDescriptionField from '../ProductInfo/ShortDescriptionField'
import { showNoEmoji, showValidWeight } from '../../../../../lib/formatter'
import { getFieldLengthMaxByName } from './util'
import validationList from './validation/validationList'
import SingleLineText from '../../ReadOnlyComponents/SingleLineText/SingleLineText'
import { WARRANTY_SCOPE_FIELD, WARRANTY_DESC_FIELD } from '../../../Shared'

export const getFieldLengthMaxConfig = fieldKey => { // FIXME: 似乎只有這裡用，以後要檢查查
  const fieldLengthMax = getFieldLengthMaxByName(fieldKey)
  return {
    placeholder: `最多輸入${fieldLengthMax}個字`,
    countLimit: fieldLengthMax
  }
}

export const getApplicantFieldProps = (identity, readOnly, isBatch = false) => {
  if (identity.isPM) {
    return {
      name: isBatch ? 'applicant' : 'setting.user.identity.name',
      validate: validationList.applicant,
      component: SingleLineTextField
    }
  }

  return {
    component: (readOnly ? SingleLineText : InputCountField)
  }
}

const fieldArray = [
  {
    name: 'applicant',
    'data-role': 'applicant',
    ...getFieldLengthMaxConfig('APPLICANT'),
    placeholder: '請輸入中文全名',
    normalizeOnBlur: removeSpaceAndTab,
    component: InputCountField
  },
  {
    name: 'product.name',
    'data-role': 'product-name',
    component: InputCountField,
    className: styles.productName,
    type: 'text',
    format: showNoEmoji,
    normalizeOnBlur: filterHtmlTagAndSpace,
    ...getFieldLengthMaxConfig('PRODUCT_NAME')
  },
  {
    name: 'listing.seoUrl',
    'data-role': 'listing-seoUrl',
    component: InputCountField,
    className: styles.seoUrl,
    type: 'text',
    normalizeOnBlur: normalizeSeoUrl,
    children: <span className={styles.suffix}>-賣場編號.html</span>,
    ...getFieldLengthMaxConfig('SEO_URL')
  },
  {
    name: 'product.shortDescription',
    'data-role': 'product-short-description',
    className: styles.shortDescription,
    component: ShortDescriptionField,
    ...getFieldLengthMaxConfig('SHORT_DESC')
  },
  {
    name: SHIP_TYPE_ID_FIELD_NAME,
    'data-role': 'product-shipType',
    component: RadioGroupInputField,
    className: styles.shipTypeIdSelect,
    simpleValue: true
  },
  {
    name: 'product.gameContents',
    'data-role': 'product-game-contents',
    popupClassName: 'product-game-contents-menu-select',
    className: styles.gameContents,
    component: CheckboxMenuSelectField,
    enableFilter: false,
    enableCustomInput: false,
    placeholder: '選擇軟體情節'
  },
  {
    name: 'product.weight',
    'data-role': 'product-weight',
    component: InputField,
    addonAfter: 'g',
    validate: validateProductWeight,
    format: showValidWeight
  },
  {
    name: 'product.contentRating',
    'data-role': 'product-content-rating',
    component: RadioGroupInputField,
    validate: validateContentRating
  },
  { /* product.models[n].items[n].warehouseBarcode used in AttributeTable */
    name: 'model.warehouseBarcode',
    component: InputField,
    validate: validateFlow(
      // 規格表尚未選擇，進倉用國際條碼不用檢查必填
      (value, allValues) => {
        const transient = _.get(allValues, '__transient__', null)
        if (!_.isNull(transient)) {
          const errorMsg = required({ msg: '請輸入12至14碼國際條碼' })(value)
          return errorMsg
        }
      },
      length({ max: 14 }),
      validateBarcode
    ),
    normalizeOnBlur: normalizeAll(removeSpaceAndTab, maxLengthNormalizer(14)),
    placeholder: '輸入12至14碼國際條碼'
  },
  { /* product.models[n].items[n].warehouseBarcode used in AttributeTable */
    name: 'model.warehouseBarcodeOld',
    component: InputField,
    validate: validateFlow(
      // 規格表尚未選擇，進倉用國際條碼不用檢查必填
      (value, allValues) => {
        const transient = _.get(allValues, '__transient__', null)
        if (!_.isNull(transient)) {
          const errorMsg = required({ msg: '請輸入進倉用國際條碼' })(value)
          return errorMsg
        }
      },
      length({ max: 13 }),
      validateBarcode
    ),
    normalizeOnBlur: normalizeAll(removeSpaceAndTab, maxLengthNormalizer(13)),
    placeholder: '輸入進倉用條碼'
  },
  { /* product.models[n].items[n].barcode used in AttributeTable */
    name: 'model.barcode',
    component: InputField,
    validate: skipRequiredThenValidate(length({ max: 14 }), validateBarcode),
    normalizeOnBlur: normalizeAll(removeSpaceAndTab, maxLengthNormalizer(14)),
    placeholder: '輸入12至14碼國際條碼'
  },
  { /* product.models[n].items[n].barcode used in AttributeTable */
    name: 'model.barcodeOld',
    component: InputField,
    validate: skipRequiredThenValidate(length({ max: 13 }), validateBarcode),
    normalizeOnBlur: normalizeAll(removeSpaceAndTab, maxLengthNormalizer(13)),
    placeholder: '輸入12或13碼國際條碼'
  },
  { /* product.models[n].items[n].partNo used in AttributeTable */
    name: 'model.partNo',
    component: InputCountField,
    validate: length({ max: 50 }),
    normalizeOnBlur: removeSpaceAndTab,
    ...getFieldLengthMaxConfig('MODEL_PART_NO'),
    placeholder: '輸入料號'
  },
  {
    name: 'product.model',
    'data-role': 'product-model',
    component: InputCountField,
    validate: length({ max: 40 }),
    normalizeOnBlur: filterHtmlTagAndSpace,
    format: showNoEmoji,
    ...getFieldLengthMaxConfig('PRODUCT_MODEL')
  },
  {
    name: 'product.brand',
    'data-role': 'product-brand',
    component: InputCountField,
    normalizeOnBlur: filterHtmlTagAndSpace,
    format: showNoEmoji,
    ...getFieldLengthMaxConfig('PRODUCT_BRAND')
  },
  {
    name: WARRANTY_SCOPE_FIELD,
    'data-role': 'product-warranty-scope',
    component: InputCountField,
    normalizeOnBlur: filterHtmlTagAndSpace,
    format: showNoEmoji,
    ...getFieldLengthMaxConfig('WARRANTY_SCOPE')
  },
  {
    name: WARRANTY_DESC_FIELD,
    'data-role': 'product-warranty-description',
    component: TextareaCountField,
    validate: length({ max: 800 }),
    normalizeOnBlur: filterHtmlTag,
    format: showNoEmoji,
    ...getFieldLengthMaxConfig('WARRANTY_DESC'),
    placeholder: '如需條列描述，可換行填寫'
  }
]

/**
 * convert field array to object as in: { product: { name: product, component: Text } }
 */
const fields = _.reduce(fieldArray, (r, field) => {
  const { name } = field
  r[name] = field
  return r
}, {})

class FieldConfig {
  constructor (options) {
    this.fields = _.merge({}, fields, options)
  }

  getField (name) {
    const field = _.get(this.fields, name, {})
    return field
  }
}

class ProductConfig extends FieldConfig {
  constructor (options) {
    super(Object.assign({
      // just for demo how you override some props from base
      // 'product.name': {
      //   moreProps: null
      // }
    }, options))
  }
}

class ListingConfig extends FieldConfig {
  constructor (options) {
    super(Object.assign({
    }, options))
  }
}

export const ProductFieldConfig = new ProductConfig()
export const ListingFieldConfig = new ListingConfig()
